import { Component } from '@angular/core';

@Component({
  selector: 'app-no-organization-in-feed',
  templateUrl: './no-organization-in-feed.component.html',
  styleUrls: ['./no-organization-in-feed.component.scss'],
})
export class NoOrganizationInFeedComponent {}
